var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchange2Line = function SvgExchange2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.75 19.125a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75m7.5-7.5a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75m-7.5 6a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m7.5-7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75M5.75 9A3.75 3.75 0 0 1 9.5 5.25h2.25v1.5H9.5A2.25 2.25 0 0 0 7.25 9v2.25h-1.5zm13.5 3.75h-1.5V15a2.25 2.25 0 0 1-2.25 2.25h-2.25v1.5h2.25A3.75 3.75 0 0 0 19.25 15z"
  })));
};
export default SvgExchange2Line;